import { Link } from 'react-router-dom';

function HomeCareerSection() {
  return (
    <section className="band bg-light ca" id="career" aria-labelledby="career-title">
      <div className="glow" aria-hidden="true" />
      <div className="wrap">
        <div className="center">
          <h2 id="career-title">Career Authoring</h2>
          <div className="sub">Your career will not grow automatically in the age of AI.<br /><span className="red">Build it intentionally. Author it strategically.</span></div>
          <p className="body">Join a new kind of career journey - one where you don&#39;t just adapt to the future, you help shape it. Accelerate toward future-ready roles with structure, mentorship and AI-enabled growth. <span className="red">Author your own success story.</span></p>
        </div>

        <div className="ca-cards">
          <div className="ca-card">
            <div className="ca-ic">
              <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false">
                <path d="M4 7h16M4 12h10M4 17h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="m15.5 14.5 4 4M18.8 11.2l3 3-3.3 3.3-3-3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
              </svg>
            </div>
            <b>Build it intentionally.</b>
          </div>
          <div className="ca-card">
            <div className="ca-ic">
              <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false">
                <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m15.5 8.5 4-4M17.5 4.5h2v2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <b>Author it strategically.</b>
          </div>
        </div>

        <div className="center">
          <Link className="btn btn-red btn-pill" to="/career-authoring-program">Start Your Career Journey</Link>
        </div>
      </div>
    </section>
  );
}

export default HomeCareerSection;
